import React from 'react';
import {
  ActionList,
  ActionListItem,
  ActionListSection,
  Dropdown,
  DropdownOverlay,
  FilterChipSelectInput,
} from '@razorpay/blade/components';

import { AddFilterMenuProps } from './types';
import { getFieldSection } from './utils';

export const AddFilterMenu = ({
  isOpen,
  isDisabled,
  sectionNames,
  fieldsAvailableToAdd,
  onOpenChange,
  onAddFilter,
}: AddFilterMenuProps) => {
  return (
    <Dropdown isOpen={isOpen} onOpenChange={onOpenChange}>
      <FilterChipSelectInput
        accessibilityLabel="Add Filter"
        label="Add Filter"
        value=""
        onChange={() => {}}
        isDisabled={isDisabled || fieldsAvailableToAdd.length === 0}
      />
      <DropdownOverlay minWidth="260px">
        <ActionList>
          {sectionNames.map((sectionName) => {
            const fieldsInSection = fieldsAvailableToAdd.filter(
              (definition) => getFieldSection(definition) === sectionName,
            );

            if (!fieldsInSection.length) return null;

            return (
              <ActionListSection key={sectionName} title={sectionName.toUpperCase()}>
                {fieldsInSection.map((definition) => (
                  <ActionListItem
                    key={definition.fieldKey}
                    title={definition.label}
                    value={definition.fieldKey}
                    onClick={() => onAddFilter(definition.fieldKey)}
                  />
                ))}
              </ActionListSection>
            );
          })}
        </ActionList>
      </DropdownOverlay>
    </Dropdown>
  );
};
